module.exports = __webpack_public_path__ + "img/btn_menu_certified_c.6de807de.png";